export const ArrowRight = () => {
	return (
		<svg
			width="9"
			height="16"
			viewBox="0 0 9 16"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M0.330363 15.6643C0.434819 15.7707 0.558909 15.8551 0.695525 15.9127C0.83214 15.9704 0.978597 16 1.12651 16C1.27442 16 1.42087 15.9704 1.55749 15.9127C1.6941 15.8551 1.8182 15.7707 1.92265 15.6643L8.66964 8.80867C8.77436 8.70253 8.85744 8.57644 8.91413 8.43763C8.97082 8.29881 9 8.14999 9 7.9997C9 7.84941 8.97082 7.70059 8.91413 7.56178C8.85744 7.42296 8.77436 7.29687 8.66964 7.19073L1.92265 0.335083C1.7115 0.120532 1.42512 1.24575e-07 1.12651 9.8472e-08C0.827897 7.23693e-08 0.541515 0.120532 0.330364 0.335083C0.119214 0.549635 0.000590075 0.840629 0.000590049 1.14405C0.000590022 1.44747 0.119213 1.73847 0.330364 1.95302L6.28345 7.9997L0.330363 14.0464C0.225642 14.1525 0.142559 14.2786 0.0858697 14.4174C0.0291805 14.5562 1.13219e-07 14.7051 1.00079e-07 14.8553C8.69387e-08 15.0056 0.0291805 15.1545 0.0858696 15.2933C0.142559 15.4321 0.225642 15.5582 0.330363 15.6643Z"
				fill="black"
			/>
		</svg>
	);
};

export const Arrow = ({ className = "w-3.5" }: { className?: string }) => {
	return (
		<svg
			className={className}
			xmlns="http://www.w3.org/2000/svg"
			fill="none"
			viewBox="0 0 6 10"
		>
			<path
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="2"
				d="M5 1 1 5l4 4"
			></path>
		</svg>
	);
};
